export const CUSTOMERS_FULL_OPTIONS = process.env.REACT_APP_FULL_OPTIONS_ON_CUSTOMERS;
